import React, { useContext } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { map } from "ramda";
import { notBlank } from "../../util/ext";
import { Link as RouterLink } from "react-router-dom";
import { ToDoContext } from "../../creator-application/dashboard/todo-context";
import clsx from "clsx";
import {
  faPhoneCircle,
  faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import WhiteIcon from "./WhiteIcon";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    minHeight: 390,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  h1: {
    fontSize: "3.6rem",
    lineHeight: "3.4rem",
    fontWeight: "bold",
    color: theme.palette.primary.contrastText,
  },

  h4: {
    color: theme.palette.primary.contrastText,
  },

  listItem: {
    padding: theme.spacing(2.5, 0),
  },

  listItemBorder: {
    borderBottomStyle: "dotted",
    borderBottomWidth: 3,
    borderBottomColor: theme.palette.primary.light,
  },

  listItemText: {
    fontSize: "1.6rem",
    color: theme.palette.primary.contrastText,
    textTransform: "none",
  },

  progressWrapper: {
    flexGrow: 1,
  },

  todoList: {
    padding: 0,
  },

  body1: {
    fontStyle: "italic",
    fontSize: "1.6rem",
    lineHeight: "1.8rem",
    color: theme.palette.primary.contrastText,
  },
}));

const ToDoLink = ({ todo, children }) => {
  return todo.url ? (
    <Link href={todo.url} target="_blank">
      {children}
    </Link>
  ) : (
    <RouterLink
      to={{
        pathname: todo.path,
        search: todo.search,
      }}
      state={{ from: "/creator/home" }}
    >
      {children}
    </RouterLink>
  );
};

const ToDoCard = () => {
  const classes = useStyles();
  const context = useContext(ToDoContext);

  return (
    <Card classes={{ root: classes.root }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" component="div" classes={{ h4: classes.h4 }}>
            Quick Actions
          </Typography>
        </Grid>
      </Grid>
      {notBlank(context.todos) ? (
        <Box mt="15px">
          <List classes={{ root: classes.todoList }}>
            {map(
              todo => (
                <ToDoLink key={todo.id} todo={todo}>
                  <ListItem
                    classes={{
                      root: clsx(classes.listItem, classes.listItemBorder),
                    }}
                  >
                    <ListItemIcon>
                      <WhiteIcon icon={todo.icon} />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{ noWrap: true }}
                      classes={{ primary: classes.listItemText }}
                      primary={todo.label}
                    />
                  </ListItem>
                </ToDoLink>
              ),
              context.todos,
            )}

            {context.isManager && (
              <Link href="https://createsharediscover.com/csp/" target="_blank">
                <ListItem
                  classes={{
                    root: clsx(classes.listItem, classes.listItemBorder),
                  }}
                >
                  <ListItemIcon>
                    <WhiteIcon icon={faQuestionCircle} />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ noWrap: true }}
                    classes={{ primary: classes.listItemText }}
                    primary="Request A New CSP"
                  />
                </ListItem>
              </Link>
            )}

            <Link href="mailto:support@biblioboard.com">
              <ListItem classes={{ root: classes.listItem }}>
                <ListItemIcon>
                  <WhiteIcon icon={faPhoneCircle} />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ noWrap: true }}
                  classes={{ primary: classes.listItemText }}
                  primary="Contact Support"
                />
              </ListItem>
            </Link>
          </List>
        </Box>
      ) : (
        <Box
          width={165}
          height={65}
          ml={"auto"}
          mr={"auto"}
          mt={12}
          textAlign="center"
        >
          <Typography
            component="div"
            variant="body1"
            classes={{ body1: classes.body1 }}
          >
            Congratulations, all of your todos have been completed.
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default ToDoCard;
